import React from 'react';

import Router from 'pages/Router';

const App = () => <Router />;
export default App;
